// extracted by mini-css-extract-plugin
export default {"main":"style_main__GAydd"};